import './MyStoresPage.less';

export const prefix = 'bm-p-my-stores';

export const navPrefix = 'bm-p-search-nav';

export { default } from './MyStoresPage';
